import { render, staticRenderFns } from "./Id.vue?vue&type=template&id=2450c4fc&"
import script from "./Id.vue?vue&type=script&lang=js&"
export * from "./Id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports